import React from 'react';
import Selector from '../atoms/Selector';

const DefaultLanguageSelector = ({
  languages = [],
  selectedLanguage = '',
  onChange,
  disabled = false,
  label = 'Select Default Language',
  subtitle = ''
}) => {
  const options = languages.map((lang) => ({
    ...lang,
    _id: lang.code,
    label: lang.name ?? lang.code // fallback if name is missing
  }));

  const selectedOption = options.find((opt) => opt._id === selectedLanguage);

  const handleChange = (option) => {
    if (option && onChange) onChange(option._id);
  };

  return (
    <div className="flex flex-col gap-5 md:gap-7 pt-7">
      {(label || subtitle) && (
        <div className="flex flex-col gap-2">
          {label && <h3 className="text-lg md:text-xl font-inter font-bold">{label}</h3>}
          <p className="text-gray-400 font-semibold">
            This language will be used for generating coverage results and for formatting the extracted document.
          </p>
          {subtitle && <p className="text-sm text-gray-400">{subtitle}</p>}
        </div>
      )}

      <div className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <Selector
          options={options}
          value={selectedOption}
          onChange={handleChange}
          isDisabled={disabled}
          placeholder="Choose a language..."
        />
      </div>
    </div>
  );
};

export default DefaultLanguageSelector;
